<template>
    <div id="layoutSidenav_nav">
        <nav class="sb-sidenav accordion sb-sidenav-light" id="sidenavAccordion">
            <div class="sb-sidenav-menu mt-1">
                <div class="nav">
                    <div class="sb-sidenav-menu-heading">Core</div>

                    <router-link class="nav-link font-weight-bold" :to="{name:'Dashboard1'}">
                        <div class="sb-nav-link-icon">
                            <font-awesome-icon icon="tachometer-alt"/>
                        </div>
                        Dashboard
                    </router-link>
<!--                    <router-link-->
<!--                        class="nav-link font-weight-bold" :to="{name:'Dashboard2'}">-->
<!--                      <div class="sb-nav-link-icon">-->
<!--                        <font-awesome-icon icon="user-friends"/>-->
<!--                      </div>-->
<!--                      Docs Dashboard-->
<!--                    </router-link>-->

                    <router-link
                            class="nav-link font-weight-bold" :to="{name:'CrewList'}">
                        <div class="sb-nav-link-icon">
                            <font-awesome-icon icon="user-friends"/>
                        </div>
                        Crewlist
                    </router-link>

                    <router-link v-if="isBldgAdmin || isSystemAdmin" class="nav-link font-weight-bold" :to="{name:'GuestList'}">
                        <div class="sb-nav-link-icon">
                            <font-awesome-icon icon="user-friends"/>
                        </div>
                        Guestlist
                    </router-link>

                 <!--   <a class="nav-link font-weight-bold" href="#">
                        <div class="sb-nav-link-icon">
                            <font-awesome-icon icon="user-friends"/>
                        </div>
                        Gueslist
                    </a>-->

                    <a v-if="isCrewOfficer || isDocAssistant || isDocSupervisor || isSystemAdmin || isOpsOfficer" class="nav-link collapsed font-weight-bold" href="#" data-toggle="collapse" data-target="#endorsement" aria-expanded="false" aria-controls="endorsement">
                      <div class="sb-nav-link-icon">
                        <font-awesome-icon icon="user-friends"/>
                      </div>
                      Endorsements
                      <div class="sb-sidenav-collapse-arrow">
                        <font-awesome-icon icon="angle-down"/>
                      </div>
                    </a>

                    <div class="collapse" id="endorsement" aria-labelledby="headingOne" data-parent="#sidenavAccordion">
                      <nav class="sb-sidenav-menu-nested nav">
                        <router-link v-if="isDocSupervisor || isDocAssistant || isSystemAdmin || isOpsOfficer" class="nav-link" :to="{name:'CrewEndorse'}">
                          Endorse Crew
                        </router-link>

                        <router-link class="nav-link" :to="{name:'CrewEndorseList'}">
                          Endorsed Crew List
                        </router-link>
                      </nav>
                    </div>

                    <router-link v-if="isBldgAdmin || isSystemAdmin" class="nav-link font-weight-bold" :to="{name:'Reservation'}">
                        <div class="sb-nav-link-icon">
                          <font-awesome-icon icon="bookmark"/>
                        </div>
                        Reservations
                    </router-link>

                    <a v-if="isBldgAdmin || isSystemAdmin" class="nav-link collapsed font-weight-bold" href="#" data-toggle="collapse" data-target="#bookings" aria-expanded="false" aria-controls="bookings">
                      <div class="sb-nav-link-icon">
                        <font-awesome-icon icon="calendar-day"/>
                      </div>
                      Bookings
                      <div class="sb-sidenav-collapse-arrow">
                        <font-awesome-icon icon="angle-down"/>
                      </div>
                    </a>

                    <div class="collapse" id="bookings" aria-labelledby="headingOne" data-parent="#sidenavAccordion">
                      <nav class="sb-sidenav-menu-nested nav">
                          <router-link v-for="hotel in sideNavHotelObjecs" :key="hotel.id" class="nav-link" :to="showRoute(hotel)">
                              {{titleCase(hotel.name)}}
                          </router-link>

                          <router-link v-if="isBldgAdmin || isSystemAdmin" class="nav-link" :to="{ name:'GuestBookingList'}">
                              Guest
                          </router-link>
                      </nav>
                    </div>

<!--                    <div class="sb-sidenav-menu-heading">Interface</div>-->

<!--                    <a class="nav-link collapsed font-weight-bold" @click="showCalendar">-->
<!--                        <div class="sb-nav-link-icon">-->
<!--                          <font-awesome-icon icon="calendar-alt"/>-->
<!--                        </div>-->
<!--                        Calendar-->
<!--                    </a>-->

                    <div v-for="hotel in allHotelFloors">
                      <a class="nav-link collapsed font-weight-bold text-capitalize"
                         href="#" data-toggle="collapse" :data-target="`#`+hotel.code"
                         aria-expanded="false" aria-controls="tnkc">
                        <div class="sb-nav-link-icon">
                          <font-awesome-icon icon="hotel"/>
                        </div>
                        {{titleCase(hotel.name)}}
                        <div class="sb-sidenav-collapse-arrow">
                          <font-awesome-icon icon="angle-down"/>
                        </div>
                      </a>
                      <div class="collapse" :id="hotel.code" aria-labelledby="headingOne" data-parent="#sidenavAccordion">
                        <nav class="sb-sidenav-menu-nested nav">
                          <!-- todo fix the guest booking
                             v-show="floor.name != 'tnkc-flr-006'"
                          -->
                          <router-link v-for="floor in hotel.floors"
                                       :key="floor.id"
                                       class="nav-link":to="{name:'Floor', params:{hotel_id: hotel.id, floor_id:floor.id}}">
                            {{titleCase(hotel.code)}} Floor {{floor.code}}
                          </router-link>
                        </nav>
                      </div>
                    </div>


                    <a v-if="isSystemAdmin" class="nav-link collapsed font-weight-bold" href="#" data-toggle="collapse" data-target="#module2" aria-expanded="false" aria-controls="module2">
                        <div class="sb-nav-link-icon">
                          <font-awesome-icon icon="cogs"/>
                        </div>
                        Settings
                        <div class="sb-sidenav-collapse-arrow">
                          <font-awesome-icon icon="angle-down"/>
                        </div>
                    </a>
                    <div class="collapse" id="module2" aria-labelledby="headingTwo" data-parent="#sidenavAccordion">
                        <nav class="sb-sidenav-menu-nested nav accordion" id="sidenavAccordionPages">

                            <router-link class="nav-link font-weight-bold" :to="{name:'Hotel'}">
                                <div class="sb-nav-link-icon">
                                    <font-awesome-icon icon="hotel"/>
                                </div>
                                Hotels
                            </router-link>

                            <router-link class="nav-link font-weight-bold" :to="{name:'EncoderView'}">
                              Encoder
                            </router-link>


                          <router-link class="nav-link font-weight-bold" :to="{name:'MailingResource'}">
                            Mailing Resource
                          </router-link>

                        </nav>
                    </div>

                    <div class="sb-sidenav-menu-heading" v-if="isSystemAdmin || isBldgAdmin">Reports</div>
                    <a class="nav-link font-weight-bold" href="#"
                       data-toggle="collapse" data-target="#reports"
                       aria-expanded="false" aria-controls="reports" v-if="isSystemAdmin || isBldgAdmin">
                        <div class="sb-nav-link-icon">
                          <font-awesome-icon icon="chart-area"/>
                        </div>
                        Reports
                      <div class="sb-sidenav-collapse-arrow">
                        <font-awesome-icon icon="angle-down"/>
                      </div>
                    </a>
                    <div class="collapse" id="reports" aria-labelledby="headingOne" data-parent="#sidenavAccordion">
                      <nav class="sb-sidenav-menu-nested nav">
                        <router-link class="nav-link" :to="{name:'ActualUtilization'}">
                          Actual Utilization
                        </router-link>
<!--                        <router-link class="nav-link" :to="{name:'CrewStatement'}">-->
<!--                          Crew Statement-->
<!--                        </router-link>-->
                      </nav>
                    </div>

                </div>
            </div>

            <div class="sb-sidenav-footer">
                <div class="small font-weight-bold">Logged in as:</div>
                <span class="font-weight-bold">{{titleCase(getUserRole)}}</span>
            </div>
        </nav>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    import {appMixins} from '../../../mixins/app.mixins';

  export default {
    name: 'layoutSidenav_nav',
    mixins:[appMixins],
    props:{
      pos: String
    },
    data(){
      return{
        //
      }
    },

    methods:{
      ...mapActions(['getHotelKeyDetails','getAllHotelFloors']),

      showCalendar(){
        let calendarRoute = this.$router.resolve({name:'Calendar',query:{data:"someData"}});
        window.open(calendarRoute.href,'_blank');
      },

      showRoute(obj){
        return { name:'BookingList',params : {hotelId : obj.id, code : obj.code, name:obj.name}}
      },
    },

    computed:{
      ...mapGetters(['sideNavHotelObjecs','userLogin','userPos','userPosCode','allHotelFloors']),

      getUserRole(){
        return this.userLogin.positions
        .map(position => position.short_name)
        .join('/');
      }
    },

    created() {
      this.getHotelKeyDetails();
      this.getAllHotelFloors();
    },

    mounted() {}
  };
</script>

<style scoped>
  .nav-link {
    font-size: 16px;
  }
  nav .nav-link:hover,
  nav .nav-link.router-link-active,
  nav .nav-link.router-link-exact-active {
    cursor: pointer;
    background-color: #32adf9;
    color: #ffffff;
  }
  /*.sb-sidenav-menu-heading {*/
  /*  font-size: 18px;*/
  /*}*/
</style>
